<template>
    <span>
      <b-card no-body>
        <b-card-header>
            <b-row>
              <b-col md="10">
                <h3>Classificar Rede</h3>
              </b-col>
            </b-row>
        </b-card-header>
        <b-card-body>
            <b-row>
              <b-col sm="8">
                <b-form-group label="Nome do Equipamento:">
                  <b-form-input type="text" id="name" v-model="filtros.filter" placeholder=""></b-form-input>
                </b-form-group>
              </b-col>
              <b-col sm="4">
                <b-form-group>
                  <b-form-group label="Situação">
                    <b-form-select class="mb-3" v-model="filtros.ativo" :options="status">
                      <template #first>
                    <b-form-select-option :value="null" disabled>Selecione</b-form-select-option>
                  </template>
                    </b-form-select>
                  </b-form-group>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="4">
                <b-form-group label="UF:">
                  <b-form-select v-model="filtros.estado_id" :options="estados" class="mb-3">
                    <option selected :value="null"> Selecione</option>
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col sm="4">
                <b-form-group label="Município:">
                  <b-form-select v-model="filtros.cidade_id" :options="cidades">
                    <option selected :value="null"> Selecione</option>
                  </b-form-select>
                </b-form-group>
              </b-col>
              <b-col sm="4">
                <b-form-group label="Categoria:">
                  <b-form-select v-model="filtros.categoria_id">
                    <option selected :value="null"> Selecione</option>
                    <option v-for="item in categorias" :key="item.id" :value="item.id"> {{item.nome}}</option>
                  </b-form-select>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
          <b-col md="2">
            <b-button @click="limpafiltro" block variant="cinza">
              <i class="fa fa-eraser"></i>
              <span>Limpar filtros</span>
            </b-button>
          </b-col>
          <b-col md="2">
            <b-button @click="pesquisar" block variant="primary">
              <i class="fa fa-search"></i>
              <span>Pesquisar</span>
            </b-button>
          </b-col>
        </b-row>
        </b-card-body>
        <b-row>
            <b-col sm="12">
                <b-container fluid>
                       <span>
                          <table aria-rowcount="4" id="my-table" aria-busy="false" aria-colcount="7" class="table table-responsive-sm table-bordered table-striped table-sm">
                          <thead>
                            <tr>
                              <th scope="col">Nome do Equipamento</th>
                              <th scope="col">UF</th>
                              <th scope="col">Município</th>
                              <th scope="col">Rede de Promoção e Proteção de DH</th>
                              <th scope="col">Situação</th>
                              <th scope="col">Ações</th>
                            </tr>
                          </thead>
                          <tbody v-if="redes.data !== undefined">
                            <tr v-for="(rede, index) in redes.data" :key="rede.id">
                              <td>{{rede.unidade}}</td>
                              <td>{{rede.estado.sigla}}</td>
                              <td>{{rede.cidade ? rede.cidade.cidade : ''}}</td>
                              <td>
                                <span v-for="categoria in rede.categorias" :key="categoria.id">
                                  {{ categoria.nome }}
                                </span>
                              </td>
                              <td>
                                <span class="badge badge-success" v-if="rede.ativo">Ativo</span>
                                <span class="badge badge-danger" v-else>Inativo</span>
                              </td>
                              <td style="width: 15%">
                                <a class="btn btn-sm btn-secondary action" title="Visualizar Rede" @click="visualizar(rede.id)">
                                  <i class="fa fa-search"></i>
                                </a>
                                <a class="btn btn-sm btn-secondary action" title="Ativar Rede" @click="ativar(rede.id)" v-if="!rede.ativo">
                                  <i class="fa fa-check"></i>
                                </a>
                                <a class="btn btn-sm btn-secondary action" title="Inativar Rede" @click="modalInativar(rede.id)" v-if="rede.ativo">
                                  <i class="fa fa-minus"></i>
                                </a>
                                <a class="btn btn-sm btn-secondary action" title="Ativar Rede" @click="abrirModalHistorico(index)">
                                  <i class="fa fa-calendar"></i>
                                </a>
                              </td>
                            </tr>
                          </tbody>
                          <tbody v-else>
                           <tr class="action">
                            <td colspan="6">Nenhum registro de rede de proteção</td>
                           </tr>
                          </tbody>
                         </table>
                         <pagination v-show="redes.data !== undefined" :totalPorPagina="totalPorPagina" :resource="resource" :filtros="filtros"></pagination>
                       </span>
                </b-container>
            </b-col>
        </b-row>
      </b-card>

      <b-modal title="Inativar Rede" size="md"  v-model="modalInativarRede" ok-only @ok="desativar()">
        <b-card-text>
          <b-form-textarea v-model="form.justificativa" placeholder="Informe a justificativa" rows="3" max-rows="6"></b-form-textarea>
        </b-card-text>
      </b-modal>

      <b-modal title="Histórico de situações" size="md"  v-model="modalHistorico" ok-only>
        <b-card-text>
          <table class="table table-responsive-sm table-bordered table-striped table-sm">
            <thead>
              <tr>
                <th scope="col">Usuário</th>
                <th scope="col">Situação</th>
                <th scope="col">Data</th>
                <th scope="col">Justificativa</th>
              </tr>
            </thead>
            <tbody v-if="historicos.length > 0">
              <tr v-for="historico in historicos" :key="historico.id">
                <td>{{ historico.user.nome }}</td>
                <td>
                  <span class="badge badge-success" v-if="historico.situacao_nova">Ativo</span>
                  <span class="badge badge-danger" v-else>Inativo</span>
                </td>
                <td>{{ historico.created_at }}</td>
                <td>{{ historico.justificativa }}</td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr>
                <tr><td colspan="4"><i>Nenhum registro histórico.</i></td>
              </tr>
            </tbody>
          </table>
        </b-card-text>
      </b-modal>
    </span>
</template>

<script>
import Vue from 'vue'
import Pagination from '@/components/shared/Pagination'
import {eventType} from '@/components/shared/eventType'
import miniToastr from 'mini-toastr'
import SessionStorage from '@/services/session-storage'

miniToastr.init()

export default {
  components: {
    Pagination
  },
  created () {
    this.$store.dispatch('buscarEstados')
    this.$store.dispatch('buscarCategoriasRedes')
    if (SessionStorage.get('tipoPerfil').replace(/['"]+/g, '') !== 'A') {
      this.$router.push('/')
    }
  },
  computed: {
    redes () {
      if (this.$store.state.pagination.getList.data !== undefined) {
        if (this.$store.state.pagination.getList.data.length !== 0) {
          return this.$store.state.pagination.getList
        } else {
          return false
        }
      }
      return this.$store.state.pagination.getList
    },
    categorias () {
      return this.$store.state.categoriaRede.listaCategoriasRedes
    },
    estados () {
      return this.$store.state.estado.listaEstados
    },
    cidades () {
      return this.$store.state.cidade.listaCidadesPorEstado
    }
  },
  data () {
    return {
      resource: 'redes-protecao',
      totalPorPagina: 10,
      situacoes: [],
      modalInativarRede: false,
      modalHistorico: false,
      form: {
        id: null,
        justificativa: null,
        categorias: []
      },
      filtros: {
        filter: '',
        ativo: null,
        estado_id: null,
        cidade_id: null,
        categoria_id: null
      },
      historicos: [],
      status: [
        {text: 'Ativo', value: true},
        {text: 'Inativo', value: false}
      ]
    }
  },
  watch: {
    'filtros.estado_id': function () {
      if (this.filtros.estado_id !== null) {
        this.$store.dispatch('buscarCidadesPorEstado', this.filtros.estado_id)
      } else {
        this.filtros.estado_id = null
      }
    }
  },
  methods: {
    can (permissao) {
      return this.$store.getters.validaPermissao(permissao)
    },
    setarFiltros (filtros) {
      eventType.$emit('app', filtros)
    },
    pesquisar () {
      this.$store.dispatch('getRegistrosSearch', {
        resource: this.resource,
        limit: this.totalPorPagina,
        filtros: this.filtros
      })
      this.setarFiltros(this.filtros)
    },
    limpafiltro () {
      this.filtros = {
        filter: '',
        ativo: null,
        estado_id: null,
        cidade_id: null,
        categoria_id: null
      }
      this.pesquisar()
    },
    abrirModalHistorico (key) {
      this.historicos = this.redes.data[key].historicos
      this.modalHistorico = true
    },
    ativar (id) {
      this.$bvModal.msgBoxConfirm('Confirma a ativação da rede selecionada?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          Vue.http.put('api/redes-protecao/' + id + '/ativa').then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
            }
          })
        }
      }).catch(erro => {
        if (!erro.body.success) {
          miniToastr.setIcon('error', 'i', {'class': 'fa fa-check'})
          miniToastr.error(erro.body.msg, 'Alerta!', 7000)
          this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
        }
      })
    },
    modalInativar (id) {
      this.form.id = id
      this.form.justificativa = null
      this.modalInativarRede = true
    },
    desativar () {
      this.$bvModal.msgBoxConfirm('Confirma a desativação da rede selecionada?', {
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          Vue.http.put('api/redes-protecao/' + this.form.id + '/inativa', {justificativa: this.form.justificativa}).then(response => {
            if (response.body.success) {
              miniToastr.setIcon('success', 'i', {'class': 'fa fa-check'})
              miniToastr.success(response.body.msg, 'Sucesso!', 7000)
              this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
            }
          })
        }
      }).catch(erro => {
        if (!erro.body.success) {
          miniToastr.setIcon('error', 'i', {'class': 'fa fa-check'})
          miniToastr.error(erro.body.msg, 'Alerta!', 7000)
          this.$store.dispatch('getRegistrosSearch', {resource: this.resource, limit: this.totalPorPagina, filtros: this.filtros})
        }
      })
    },
    visualizar (id) {
      let cat = ''
      if (this.filtros.categoria_id) {
        cat = '/' + this.filtros.categoria_id
      }
      this.$router.push('/rede/visualizar/' + id + cat)
    },
    limpar () {
      this.filtros.filter = ''
      this.filtros.categoria = null
      this.filtros.ativo = null
      this.filtros.estado_id = null
      this.filtros.cidade_id = null
    },
    navigate (route) {
      this.$router.push(route)
    }
  }
}
</script>

<style scoped>
    .action{
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/pages/site/interna/administrador/rede/Rede.vue